module.exports = __webpack_public_path__ + "media/images/covid/cs/closed_spaces-96df0a5567c02a1ed08484b2f8b8bcc1.png";